<div class="skl-cmdb-sync" aria-busy="true" aria-label="Loading CMDB sync information">
  <div class="skl-tabs">
    @for (tab of tabs; track tab) {
      <app-skeleton [width]="tab === 1 ? '94px' : tab === 2 ? '110px' : '82px'" height="32px" borderRadius="16px" marginBottom="0"></app-skeleton>
    }
  </div>

  <div class="skl-panel">
    <div class="skl-card">
      <div class="skl-card__body skl-card__body--actions">
        <app-skeleton width="110px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        <app-skeleton width="116px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    </div>

    <app-cmdb-sync-history-skeleton></app-cmdb-sync-history-skeleton>
  </div>
</div>